import { StyleSheet } from 'react-native';

import { COLOR, whiteTransparent } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isTablet,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    title: {
        height: heightPercentageToDP(80),
        paddingBottom: heightPercentageToDP(16),
        justifyContent: 'flex-end',
        zIndex: 100,
    },
    backButtonText: {
        color: COLOR.WHITE,
    },
    button: {
        width: widthPercentageToDP(328, 120),
    },
    qrButton: {
        borderWidth: isTablet ? 2 : 1.5,
        borderColor: isTablet ? whiteTransparent(0.3) : whiteTransparent(0.7),
    },
    qrButtonText: {
        color: COLOR.WHITE,
        marginLeft: 8,
    },
    errorButton: {
        width: 'auto',
        minWidth: 120,
        paddingVertical: 8,
        paddingHorizontal: 18,
    },
    container: {
        marginBottom: androidScreenMarginBottom,
    },
});

export default styles;
